import React from 'react';
import cx from 'clsx';

import Layout from '../components/Layout';
import announcementQuery from '../query/announcementQuery';
import NewsCard from '../components/NewsCard';
import * as themeStyles from '../assets/theme.module.scss';
import { genAnnouncementUrl } from '../utils/urls';
import { getDocumentPlanExcerpt } from '../utils/contentful';

const IndexRoute = ({ pageContext }) => {
    const news = announcementQuery();
    return (
        <Layout pageContext={pageContext}>
            <section className={cx(themeStyles.py6, themeStyles.pyMd6, themeStyles.borderBottom, themeStyles.bgLight)}>
                <div className={themeStyles.container}>
                    <div className={cx(themeStyles.row, themeStyles.justifyContentCenter)}>
                        <div className={cx(themeStyles.col12, themeStyles.colMd10, themeStyles.colLg8, themeStyles.textCenter)}>
                            <h1 className={themeStyles.display3}>
                                公告
                            </h1>
                        </div>
                    </div>
                    {news.map((item) => (
                        <NewsCard
                            key={item.key}
                            title={item.title}
                            url={genAnnouncementUrl(item.url)}
                            date={item.date}
                            excerpt={getDocumentPlanExcerpt(item.content.raw)}
                            tags={item.tags}
                        />
                    ))}
                </div>
            </section>
        </Layout>
    );
};

export default IndexRoute;
